import { createContext, useContext, useState } from 'react'

const CategoryFarmContext = createContext(null)

export const CategoryFarmProvider = ({ children }) => {
  const [categoryFarm, setCategoryFarm] = useState()
  const [categoryTitle, setCategoryTitle] = useState()

  return (
    <CategoryFarmContext.Provider value={{ categoryFarm, setCategoryFarm, categoryTitle, setCategoryTitle }}>
      {children}
    </CategoryFarmContext.Provider>
  )
}

export const useCategoryFarm = () => {
  const context = useContext(CategoryFarmContext)

  if (!context) throw new Error('Necessário utilizar o CategoryFarmProvider')

  return (
    { ...context }
  )
}

export const useCategoryTitle = () => {
  const context = useContext(CategoryFarmContext)

  if (!context) throw new Error('Necessário utilizar o CategoryFarmProvider')

  return (
    { ...context }
  )
}
